/* GRIYGO: botão fixo usa a ação original do produto, respeitando variantes e quantidade. */
if (!customElements.get('griygo-sticky-buy')) {
  customElements.define('griygo-sticky-buy', class GriygoStickyBuy extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.productInfo = document.getElementById(`MainProduct-${this.sectionId}`);
      this.stickyButton = this.querySelector('.griygo-sticky-buy__button');
      this.stickyText = this.querySelector('.griygo-sticky-buy__button-label');
      if (!this.productInfo || !this.stickyButton) return;

      this.onStickyClick = () => {
        const original = this.originalButton();
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
        // Reutiliza o formulário Ajax nativo do tema. Não cria variantes, requisições
        // de compra ou fluxos de pagamento paralelos.
        original.click();
        this.scheduleUpdate();
      };
      this.stickyButton.addEventListener('click', this.onStickyClick);

      this.onViewportChange = () => this.scheduleUpdate();
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange);

      this.onProductChange = () => this.scheduleUpdate();
      this.productInfo.addEventListener('change', this.onProductChange);

      // Ao selecionar uma variante, o Dawn atualiza o botão nativo de forma
      // assíncrona. O observador acompanha os estados (esgotado/indisponível).
      this.observer = new MutationObserver(() => this.scheduleUpdate());
      this.observer.observe(this.productInfo, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.stickyButton?.removeEventListener('click', this.onStickyClick);
      window.removeEventListener('scroll', this.onViewportChange);
      window.removeEventListener('resize', this.onViewportChange);
      this.productInfo?.removeEventListener('change', this.onProductChange);
      this.observer?.disconnect();
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }

    originalButton() {
      return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    }

    scheduleUpdate() {
      if (this.updateFrame) return;
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateState();
      });
    }

    updateState() {
      const original = this.originalButton();
      if (!original || !original.isConnected) {
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
        return;
      }

      // Só aparece depois que a pessoa passou pelo botão original.
      // Ao rolar para cima, desaparece quando o botão original reaparece.
      const headerBottom = Math.max(0, document.querySelector('.header-wrapper')?.getBoundingClientRect().bottom || 0);
      const pastOriginal = original.getBoundingClientRect().bottom < Math.min(headerBottom, 180);
      this.classList.toggle('is-visible', pastOriginal);
      this.setAttribute('aria-hidden', pastOriginal ? 'false' : 'true');

      const disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      this.stickyButton.disabled = disabled;
      this.stickyButton.setAttribute('aria-disabled', String(disabled));
      this.stickyText.textContent = disabled
        ? (original.querySelector('span')?.textContent?.trim() || 'Indisponível')
        : (this.dataset.label || 'Comprar agora');
    }
  });
}
